<template>
  <div class="main">
    <div class="auth-module">
      <Authenticator
        :auth-data="authData"
        :auth-state="authState"
      />
    </div>
  </div>
</template>

<script>
import Authenticator from '@/auth/components/Authenticator'

export default {
  name: 'Login',
  components: {
    Authenticator
  },
  data: function () {
    return {
      authData: {},
      authState: 'signIn'
    }
  },
  computed: {},
  methods: {
    setAuthenticatedUser() {
      // TODO
      //  Yet to code to set Authenticated USer
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
  @import '~@/assets/styles/auth.scss'
</style>

